import { projectData } from '@/constants/constants';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TopSectionSkeleton: React.FC = () => {
  return (
    <div className="flex items-center justify-between pb-4 px-8 mx-2 mb-6 rounded-lg shadow w-full gap-5">
      {/* NewCase section */}
      <div className="w-1/6">
        <h1 className="text-2xl xl:text-3xl font-normal text-[#84888f] whitespace-nowrap min-w-62">
          {projectData.name}
        </h1>
      </div>

      {/* the tabs section */}
      <div className="flex gap-5 w-full">
        <div className="w-1/6">
          <Skeleton height={30} borderRadius={20} />
        </div>
        <div className="w-1/6">
          <Skeleton height={30} borderRadius={20} />
        </div>
        <div className="w-1/6">
          <Skeleton height={30} borderRadius={20} />
        </div>
        <div className="w-1/6">
          <Skeleton height={30} borderRadius={20} />
        </div>
      </div>
    </div>
  );
};

export default TopSectionSkeleton;
